import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import {
  DialogAdditionalParamKey,
  DialogKey,
} from '@sorare/core/src/components/navigation/WithDialogs';
import { useOpenDialog } from '@sorare/core/src/hooks/navigation/useOpenDialog';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';

import { CashRewards } from 'components/onboarding/WinItems/CashRewards';

import { Prizes_so5Leaderboard } from './__generated__/index.graphql';

const ButtonWrapper = styled(Horizontal)`
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  bottom: var(--double-unit);
  z-index: 1;
`;

type Props = {
  so5Leaderboard: Nullable<Prizes_so5Leaderboard>;
};

export const Prizes = ({ so5Leaderboard }: Props) => {
  const track = useEvents();
  const openDialog = useOpenDialog();
  return (
    <CashRewards>
      <ButtonWrapper center>
        <Button
          color="secondary"
          size="medium"
          onClick={() => {
            if (!so5Leaderboard) {
              return;
            }
            track('Click Prize Pool In Guidance First Lineup', {});
            openDialog(
              DialogKey.competitionDrawer,
              so5Leaderboard.so5LeaderboardGroup.slug,
              {
                additionalParams: {
                  [DialogAdditionalParamKey.trck]:
                    so5Leaderboard.so5LeagueTrack.slug,
                  [DialogAdditionalParamKey.trckGrp]:
                    so5Leaderboard.so5LeagueTrack.groupSlug,
                  [DialogAdditionalParamKey.hideFixtureCompetitionTabs]: 'true',
                },
              }
            );
          }}
        >
          <FormattedMessage
            id="Prizes.viewPrizePool"
            defaultMessage="*View Prize Pool"
          />
        </Button>
      </ButtonWrapper>
    </CashRewards>
  );
};

Prizes.fragments = {
  so5Leaderboard: gql`
    fragment Prizes_so5Leaderboard on So5Leaderboard {
      slug
      so5LeaderboardGroup {
        slug
      }
      so5LeagueTrack {
        slug
        groupSlug
      }
    }
  ` as TypedDocumentNode<Prizes_so5Leaderboard>,
};
